import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/Home.css";
import "animate.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLightbulb, faUsersGear } from "@fortawesome/free-solid-svg-icons";
import investIMG from "../images/compressed.webp";
import loginIMG from "../images/page.webp";
import mamitoIMG from "../images/mamito.jpeg";
import girlieIMG from "../images/girlie.jpeg";
import broIMG from "../images/bro.jpeg";
import homeBg from "../images/hero-img-2.jpg";
import useInView from "../lib/useInView";
import privateMoney from "../images/private-money.webp";
import Stocks from "../components/stocks/Stocks";
import Market from "../components/stocks/Market";

const HomePage = () => {
  const BRAND_NAME = process.env.REACT_APP_BRAND_NAME;

  const navigate = useNavigate();
  const words = ["Online Banking", "Investment Broker", "Loans and Grants"];
  const [currentWordIndex, setCurrentWordIndex] = useState(0);

  // Cycle through words every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentWordIndex((prevIndex) => (prevIndex + 1) % words.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [words.length]);

  // to handle animations using the custom 'in view' hook
  const [boxImageRef, boxImageInView] = useInView({ threshold: 0.5 });
  const [boxVidRef, boxVidInView] = useInView({ threshold: 0.5 });
  const [boxImgRef, boxImgInView] = useInView({ threshold: 0.5 });
  const [boxImg1Ref, boxImg1InView] = useInView({ threshold: 0.5 });
  const [box5Ref, box5InView] = useInView({ threshold: 0.7 });
  const [box6Ref, box6InView] = useInView({ threshold: 0.7 });
  const [box7Ref, box7InView] = useInView({ threshold: 0.7 });
  const [box8Ref, box8InView] = useInView({ threshold: 0.7 });
  const [box9Ref, box9InView] = useInView({ threshold: 0.7 });

  return (
    <>
      <div className="main-wrapper" id="hero-section">
        <div className="main-bottom-grid">
          {/* 1/3 Image */}
          <div className="main-side-image">
            <img src={investIMG} alt="Side" />
          </div>

          {/* 2/3 Content */}
          <div className="main-content">
            <h1 className="hero-title">
              Fit your financial life with our{" "}
              <span className="handwriting">{words[currentWordIndex]}</span>
            </h1>

            <p className="hero-description">
              Turn your plans into goals,{" "}
              <span className="circle-text">internationally and locally.</span>
            </p>
            <div className="sub-container">
              <div className="sub-box" onClick={() => navigate("/about-us")}>
                Savings
              </div>
              <div className="sub-box" onClick={() => navigate("/loans")}>
                Loans
              </div>
              <div className="sub-box" onClick={() => navigate("/investments")}>
                Investments
              </div>
            </div>
          </div>
        </div>
        <Stocks />
      </div>

      {/* main page content */}
      <div className="heading-cover-bg">
        <div className="last-section">
          {/* Box 1: Text */}
          <div className="box">
            <h2 className="box-title" id="white-title">
              You Deserve a Bank That Cares
            </h2>
            <div className="box-text">
              When you work with the professional business bankers at
              <strong> {BRAND_NAME}</strong>, you’re working with knowledgeable
              local advisors who take the time to truly understand your
              business. We’ll work with you so that you can take advantage of
              opportunities when they come your way.
              <br />
              <br />
              We’ll help you see all your options and work with you to find the
              right one, so you can confidently move forward to take your
              business to the next level.
            </div>
          </div>

          {/* Box 2: Image */}
          <div className="box">
            <img
              src={homeBg}
              id="box-saving"
              alt={BRAND_NAME}
              ref={boxImageRef}
              className={`box-image animate__animated ${boxImageInView ? "animate__zoomIn" : ""}`}
            />
          </div>

          {/* Box 3: Icon, Heading, and Text */}
          <div className="box">
            <div
              ref={box6Ref}
              className={`icon-title-text-container animate__animated ${box6InView ? "animate__zoomInRight" : ""}`}
            >
              <FontAwesomeIcon icon={faLightbulb} className="box-icon" />
              <div className="title-text">
                <h3 className="box-title" id="white-title">
                  START WITH YOUR GOALS
                </h3>
                <div className="box-text">
                  What do you want to accomplish with your business today, next
                  year and into the future?
                </div>
              </div>
            </div>

            <div
              ref={box5Ref}
              className={`icon-title-text-container animate__animated ${box5InView ? "animate__zoomInRight" : ""}`}
            >
              <FontAwesomeIcon icon={faUsersGear} className="box-icon" />
              <div className="title-text">
                <h3 className="box-title" id="white-title">
                  CUSTOM TAILORED FOR YOU
                </h3>
                <div className="box-text">
                  We’ll explore creative solutions together, so you understand
                  what’s possible.
                </div>
              </div>
            </div>

            <button
              onClick={() => {
                navigate("/login");
              }}
              className="delete-button"
            >
              Get Started
            </button>
          </div>
        </div>
      </div>

      {/* Trading Market */}
      <div>
        <Market />
      </div>

      {/* About Bank and Video */}
      <div className="video-section">
        <div className="hero-text-container">
          <h2 className="box-title"> Care, Clarity, and Confidence</h2>
          <h2 className="hero-title">
            We want to show you what it’s like to be with a bank that cares.
          </h2>
          <button
            onClick={() => {
              navigate("/about-us");
            }}
            className="delete-button"
          >
            More About Us
          </button>
        </div>
        <div
          ref={boxVidRef}
          className={`hero-image-container animate__animated ${boxVidInView ? "animate__zoomIn" : ""}`}
        >
          <img
            ref={boxImg1Ref}
            src={privateMoney}
            alt={BRAND_NAME}
            className={`box-image animate__animated ${boxImg1InView ? "animate__pulse" : ""}`}
          />
        </div>
      </div>

      {/* Card Application section */}
      <div className="card-section">
        <div className="card-grid-container">
          {/* Card Display */}
          <div className="card-panel">
            <h2 className="card-panel-title">{BRAND_NAME} Card</h2>
            <div className="credit-card-preview">
              <div className="card-top">
                <div className="card-logo">{BRAND_NAME}</div>
                <div className="card-chip"></div>
              </div>
              <div className="card-number">1234 5678 9012 3456</div>
              <div className="card-details">
                <div className="card-info">
                  <div className="info-row">
                    <span className="label">Cardholder Name</span>
                    <div className="value">John Doe</div>
                  </div>
                  <div className="info-row">
                    <span className="label">Expires</span>
                    <div className="value">03/29</div>
                  </div>
                </div>
                <div className="card-brand">Mastercard</div>
              </div>
            </div>
          </div>

          {/* Apply Form */}
          <div className="apply-panel">
            <h2 className="apply-title">
              Apply for the {BRAND_NAME} MasterCard
            </h2>
            <p className="apply-desc">
              With a {BRAND_NAME} Card, you gain access to features that make
              spending across borders easy and rewarding:
            </p>
            <ul className="card-benefits-list">
              <li>Seamless international payments including crypto.</li>
              <li>Widely accepted across over 200 countries and territories</li>
              <li>
                24/7 global customer support and emergency card replacement
              </li>
            </ul>
            <button className="apply-button" onClick={() => navigate("/login")}>
              Apply Now
            </button>
          </div>
        </div>
      </div>

      {/* footer content for home */}
      <div className="main-box-cover">
        <h2 className="text-heading centered">
          More Choices - <span> More Possibilities.</span>
        </h2>
        <div className="hero-description centered">
          We offer our clients comprehensive investment solutions that are
          tailored to each particular client’s needs at a specific period of
          time. For 17 years, we have been providing secure and easy offshore
          banking to over 400,000 who live, travel, shop and work arpund the
          world. We make cross-border banking easy and secure.
        </div>
      </div>

      <div className="last-section">
        <div className="box">
          <img
            ref={boxImgRef}
            src={loginIMG}
            alt="Sky High National Trust Bank"
            className={`box-image animate__animated ${boxImgInView ? "animate__pulse" : ""}`}
          />
          <h2 className="text-heading centered">
            Navigate complexity with a trusted capital markets services partner
            at your side
          </h2>
        </div>
        <div className="box">
          <div
            ref={box7Ref}
            className={`icon-title-text-container animate__animated ${box7InView ? "animate__zoomInRight" : ""}`}
          >
            <img
              src={mamitoIMG}
              className="boxed-icon"
              alt="WORKING AND INVESTING INTERNATIONALLY"
            />
            <div className="title-text">
              <h2 className="box-title">
                WORKING AND INVESTING INTERNATIONALLY
              </h2>
              <div className="hero-description">
                Explore endless career and investment opportunities – from
                building a thriving career to making smart financial moves in
                one of the world's strongest economies.{" "}
              </div>
            </div>
          </div>

          <div
            ref={box8Ref}
            className={`icon-title-text-container animate__animated ${box8InView ? "animate__zoomInRight" : ""}`}
          >
            <img
              src={broIMG}
              className="boxed-icon"
              alt="RELOCATING AND SCHOOLING IN THE ABROAD"
            />
            <div className="title-text">
              <h2 className="box-title">RELOCATING AND SCHOOLING ABROAD.</h2>
              <div className="hero-description">
                Make your move abroad seamless — discover the best schools,
                opportunities, and everything you need for a successful
                transition.
              </div>
            </div>
          </div>

          <div
            ref={box9Ref}
            className={`icon-title-text-container animate__animated ${box9InView ? "animate__zoomInRight" : ""}`}
          >
            <img
              src={girlieIMG}
              className="boxed-icon"
              alt="INTERNATIONAL BUSINESS WITH FOREIGNERS"
            />
            <div className="title-text">
              <h2 className="box-title">
                INTERNATIONAL BUSINESS WITH FOREIGNERS
              </h2>
              <div className="hero-description">
                Seamlessly conduct international transactions, manage foreign
                investments, and build strong financial partnerships with global
                banking solutions.{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HomePage;
